import { render } from "./BaseTable.vue?vue&type=template&id=5cbff9af&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=5cbff9af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbff9af"]])

export default __exports__